import React from 'react';

import {Row,Col,Container} from 'react-bootstrap';

import Logo from './../../assets/image/logo.png';
import GouvQC from './../../assets/image/logo_gouv_qc.png';
import HydroQC from './../../assets/image/logo_hydro_qc.png';
import MNQ from './../../assets/image/logo_mnq.png';
import Quebecor from './../../assets/image/logo_quebecor.png';
import SAQ from './../../assets/image/logo_saq.png';

import SocialLink from '../../components/SocialLink/SocialLink.js'

import './Footer.scss'

const Footer = () => {
    return (<footer className="Footer">
        {/*<div className="pt-13 pb-16 bg-white">
            <Container>
                <h3>Partenaires</h3>
                <div className="d-flex flex-wrap align-items-center justify-content-between mt-2">
                    <img src={GouvQC} className="mb-2" alt="Gouvernement du Québec" />
                    <img src={HydroQC} className="mb-2" alt="HydroQuébec" />
                    <img src={Quebecor} className="mb-2" alt="Québecor" />
                    <img src={SAQ} className="mb-2" alt="Société des Alcools du Québec" />
                    <img src={MNQ} className="mb-2" alt="Mouvement National des Québecois" />
                </div>
            </Container>
        </div>*/}
        <div className="pt-md-16 pt-6 Footer-main">
            <Container>
                <Row>
                    <Col md="3"><img src={Logo} alt="Fête nationale du Québec" loading="lazy" className="Logo"/></Col>
                    <Col md="4" className="d-none d-md-block FooterMenuCol--festivites">
                        <ul className="FooterMenu">
                            <li><a href="https://fetenationale.gouv.qc.ca/capitale-nationale/">Fête nationale du Québec dans la capitale</a></li>
                            <li><a href="https://fetenationale.gouv.qc.ca/montreal/">Fête nationale du Québec à Montréal</a></li>
                            <li><a href="https://programmation.fetenationale.gouv.qc.ca/">Calendrier national des festivités</a></li>
                        </ul>
                    </Col>
                    <Col md="2" className="d-none d-md-block">
                        <ul className="FooterMenu">
                            <li><a href="https://fetenationale.gouv.qc.ca/porte-parole/">Porte-parole</a></li>
                            <li><a href="https://fetenationale.gouv.qc.ca/theme-commemoratif-2026/">Thème commémoratif</a></li>
                            <li><a href="https://fetenationale.gouv.qc.ca/partenaires/">Partenaires</a></li>
                        </ul>
                    </Col>
                    <Col md="3" className="d-none d-md-block">
                        <ul className="FooterMenu">
                            <li><a href="https://fetenationale.gouv.qc.ca/nouvelles/">Actualités</a></li>
                            <li><a href="https://fetenationale.gouv.qc.ca/nous-joindre/">Nous joindre</a></li>
                            <li><a href="https://app.cyberimpact.com/clients/55486/subscribe-forms/37863EBF-7AD7-4232-A566-4AB46240038F">Infolettre</a></li>
                        </ul>
                    </Col>
                </Row>
                <div className="mt-3 d-block d-md-none">
                    <SocialLink variant="facebook" />
                    <SocialLink variant="instagram" />
                    <SocialLink variant="x" />
                    <SocialLink variant="youtube" />
                </div>
                <div  className="Colophon mt-5 pt-3 pb-3">
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="text-right d-none d-md-block">
                            <SocialLink variant="facebook" />
                            <SocialLink variant="instagram" />
                            <SocialLink variant="x" />
                            <SocialLink variant="youtube" />
                        </div>
                    </div>
                </div>
            </Container>
            <div className="mt-3 pt-5 pb-3 bg-white">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <img src={GouvQC} alt="Logo du Gouvernement du Québec" className="mb-2" style={{ height: '40px' }} />
                        <p className="text-center mb-0"><a href="https://www.quebec.ca/droit-auteur" target="blank">© Gouvernement du Québec, 2025</a></p>
                    </div>
                </div>
        </div>
    </footer>)
}

export default Footer;